import { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  title?: string;
};

const PageMainContainer: FC<Props> = ({ children, title = 'Overview' }) => {
  return (
    <div className="tw-flex tw-justify-center">
      <div className="tw-w-full tw-max-w-[1616px]">{children}</div>
    </div>
  );
};

export default PageMainContainer;
